module.exports = __webpack_public_path__ + "fonts/3ce0c6b.otf";